var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 0 2.36 6.875H20l-6.18 4.25L16.18 18 10 13.75 3.82 18l2.36-6.875L0 6.875h7.64L10 0Z",
    fill: "#EEF2F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlineIcon);
export default __webpack_public_path__ + "static/media/star-outline-icon.a6daab839238a420f8349206301cfb8b.svg";
export { ForwardRef as ReactComponent };